<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal">

    <template v-slot:Body>
      <div class="col-md-12">
        <div style="float:right;width:3%;">&nbsp;</div>

        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreAl">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora -1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.AllaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;">
          <label style="float:left;min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreDal">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora - 1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.DallaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:11%;text-align: right; padding-right: 15px;min-width:30px">
          <label>{{ this.GetTraduzioneLabel('Generic','TKN_STORICO_DAL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:3%;">&nbsp;</div>
        <div style="clear:both;height:10px"></div>
      </div>



      <div class="col-md-12">
        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="width:57%;float:left;">
          <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupStazioneMeteo','TKN_POPUP_STAZ_METEO_SPOST_MOD',this.LinguaUtente) }}</text>
          </div>
          
          <div style="overflow:auto" :style="{'max-height': (parseInt(AltezzaPopup) - 100) + 'px'}" >
            <template v-for="(OggettoModulo, index) in FiltraModuli" :key="index">
              <div style="background-color:white;">
                <div style="float:left;width:3%;">&nbsp;</div>
                <input style="float:left;width:3%;margin-top:4px;padding: 0px;height: 20px" type="checkbox" class="form-control" v-model="OggettoModulo.Selezionato"/>
                <div style="float:left;width:2%;">&nbsp;</div>
                <text style="float:left;width:92%;margin-top:2px;font-size:16px"> {{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ OggettoModulo.Id }}</text>
                <div style="clear:both"></div>
              </div>
            </template>
          </div>
        </div>
        
        <div style="float:left;width:2%;">&nbsp;</div>

        <div style="width:35%;float:left" ref="DivPulsanti">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickSelezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickDeselezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickInvertiTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('VUEPopupStazioneMeteo','TKN_POPUP_STAZ_METEO_INT_PROF',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:10px"></div>



          <!-- <div v-if="AppareCheckVisualizzaMarkup()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.VisualizzaMarkup"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Visualizza markup</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div> -->

          <!-- <div v-if="AppareCheckInterpMinQuad()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.InterpMinimiQuadrati"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Interp. minimi quadrati</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div> -->

          <div>
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:96%;">
              <div style="float:left;width:67%">
                <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;margin-top:5px">{{ this.GetTraduzioneLabel('VUEPopupStazioneMeteo','TKN_POPUP_STAZ_METEO_ASSE_N',this.LinguaUtente) }}</label>
              </div> 
              <div style="float:left;width:33%">
                <input step="0.01" style="float:left;" type="number" class="form-control" v-model="Filtro.OrientamentoAsse"/>
              </div> 
            </div>
            <div style="clear:both;height:10px"></div>
          </div>

          <!-- <div v-if="ApparePeriodoMedia()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:96%;">
              <div style="float:left;width:75%">
                <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;margin-top:5px">Periodo media</label>
              </div> 
              <div style="float:left;width:25%">
                <input style="float:left;" type="number" class="form-control" v-model="Filtro.PeriodoMedia"/>
              </div> 
            </div>
            <div class="ZMDistanziatore"></div>
          </div> -->

        </div>

        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="clear:both;height:4px"></div>

      </div>

    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>
</template>

<script>

import VUEModal from '@/utils/VUEModal.vue';            
import { COLORI_PANTONE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, SFONDO, TInfoGraficiStorici, LOCALSTORAGE } from '@/SystemInformation'
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            ColoriSfondo          : SFONDO,
            TipologiaGrafici      : TIPOLOGIA_GRAFICI_STORICI,
            TipologiaPopup        : SystemInformation.TipoPopupAperto,
            Filtro                : {
                                      Piezometri           : false,
                                      Estensimetri         : false,
                                      AllaData             : '',
                                      OreDal               : 0,
                                      OreAl                : 23,
                                      DallaData            : '',
                                      VisualizzaMarkup     : false,
                                      InterpMinimiQuadrati : false,
                                      OrientamentoAsse     : null,
                                      PeriodoMedia         : 0,
                                      AllineamentoIncl     : null, 
                                      AllineamentoTemp     : null,
                                      AllineamentoDef      : null,
                                    },
            GrandezzaDivPulsanti  : {
                                      Height : 0
                                    },
            URLSchedaStorici      : '/appMainWindow/GraficiStorici',

            PopupAllineamentoInclinazioni : false,
            PopupAllineamentoTemp         : false,
            PopupAllineamentoDeformazioni : false,
            LinguaUtente                  : SystemInformation.UserInformation.Lingua,
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjCatena', 'VettoreModuli'],
  emits : ['OnClickChiudiPopup'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },


    OnClickConfermaModal()
    {
      let ModuliSelezionati = this.FiltraModuli.filter((element) => {return element.Selezionato})
      if (ModuliSelezionati.length == 0)
        ModuliSelezionati.push({Id : -1})
      SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.ObjCatena.DatiCatena.CHIAVE_SITO, 
                                                                            this.ObjCatena.DatiCatena.CHIAVE,
                                                                            this.ObjCatena.Descrizione,
                                                                            this.TipologiaPopup,
                                                                            ModuliSelezionati, 
                                                                            new Date(this.Filtro.DallaData), 
                                                                            new Date(this.Filtro.AllaData), 
                                                                            this.Filtro.OreDal, 
                                                                            this.Filtro.OreAl,
                                                                            this.Filtro.VisualizzaMarkup,
                                                                            this.Filtro.InterpMinimiQuadrati,
                                                                            this.Filtro.OrientamentoAsse,
                                                                            this.Filtro.PeriodoMedia)

      
      SystemInformation.OggettoInfoGraficiStorici.VisualizzaPluviometro = this.ObjCatena.DatiCatena.PLUVIOMETRO
      SystemInformation.OggettoInfoGraficiStorici.VisualizzaAnemometro  = this.ObjCatena.DatiCatena.ANEMOMETRO
      SystemInformation.OggettoInfoGraficiStorici.VisualizzaTermometro  = this.ObjCatena.DatiCatena.TERMOMETRO
      SystemInformation.OggettoInfoGraficiStorici.VisualizzaSpostamento = this.ObjCatena.DatiCatena.INCLINOMETRI
      
      if(this.Filtro.AllineamentoIncl != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoIncl     = this.Filtro.AllineamentoIncl
      if(this.Filtro.AllineamentoTemp != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoTemp     = this.Filtro.AllineamentoTemp
      if(this.Filtro.AllineamentoDef != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoDef      = this.Filtro.AllineamentoDef
      
      SystemInformation.OggettoInfoGraficiStorici.ListaFalde             = this.VettoreModuli.filter((element) => {return element.Piezometro})
      
      SystemInformation.OggettoInfoGraficiStorici.ListaTuttiModuli       = this.VettoreModuli

      SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena   = this.$route.fullPath
      
      localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
      localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici));

      this.$router.push(this.URLSchedaStorici)
    },

    OnClickSelezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = true
        });
      }
    },

    OnClickDeselezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = false
        });
      }
    },

    OnClickInvertiTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = !Modulo.Selezionato
        });
      }
    },

    CalcolaGrandezzaDivPulsanti()
    {
      this.GrandezzaDivPulsanti.Height = this.$refs.DivPulsanti.clientHeight
    },

    GetAWeekAgo()
    {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      return date
    },

    ControlloDateInserite()
    {
      if(this.Filtro.DallaData != '' && this.Filtro.AllaData != '' && this.Filtro.OreDal !== '' && this.Filtro.OreAl !== '')
      {
        if(this.Filtro.DallaData + ' ' + this.Filtro.OreDal < this.Filtro.AllaData + ' ' + this.Filtro.OreAl)
          return true
      }
      return false
    },

    ControlloModuloSelezionato()
    {
      let Result = this.FiltraModuli.some(Filtro => Filtro.Selezionato)
      return Result
    },

    CanRecord()
    {
      return this.ControlloDateInserite() &&
             this.ControlloModuloSelezionato() &&
             this.Filtro.OrientamentoAsse !== '' &&
             this.Filtro.OrientamentoAsse !== null
             
    },

    GestisciDateGrafica(Data)
    {
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data))
    },

  },
  
  computed:
  {
    FiltraModuli :
    {
      get()
      {
        let Self   = this
        let Result = []
        Result     = this.VettoreModuli
      
        if(this.Filtro.Estensimetri || this.Filtro.Piezometri)
        {
          Result = Result.filter(function(Modulo)
          {
            if(Self.Filtro.Piezometri && Modulo.Piezometro)
              return true
            if(Self.Filtro.Estensimetri && Modulo.Estensimetro)
              return true
            return false
          })
        }

        return Result
      }
    }
  },

  beforeMount()
  {
    this.Filtro.AllaData  = TZDateFunct.FormatDateTime('yyyy-mm-dd',new Date())
    this.Filtro.DallaData = TZDateFunct.FormatDateTime('yyyy-mm-dd',this.GetAWeekAgo())
  },

  mounted()
  {
    this.CalcolaGrandezzaDivPulsanti()
  },

  watch:
  {
    'Filtro.OrientamentoAsse': 
      function (newValue) 
      {
        if(newValue != '')
        {
          if (isNaN(newValue)) 
            this.Filtro.OrientamentoAsse = 0;
          else this.Filtro.OrientamentoAsse = Math.max(0, Math.min(359.99, parseFloat(newValue)));
        }
      },
  },
}
</script>